<template>
    <div>
        <v-form @submit.prevent="requestQuote" ref="form" v-model="valid" id="raqForm">
            <v-card outlined tile class="elevation-0 form-card">
                <v-card-text class="pt-6 pb-6 pr-6 pl-6">
                    <v-row>
                        <v-col cols="7" sm="3" md="7">
                            <span class="input-control-text">Date of Birth</span>
                            <v-text-field
                                placeholder="MM/DD/YYYY"
                                outlined
                                v-model="dob"
                                :rules="isOCSite ? [] : [rules.dob, outside_age_range]"
                                hide-details="auto"
                                dense
                                v-mask="'##/##/####'"
                                class="input-control-text field-medium"
                                id="dob"
                                @focus="dob_focus = true"
                                type="text"
                                inputmode="numeric"
                                >
                            </v-text-field>
                            <span v-if="!isOCSite" class="input-control-text-small">You must be between 18 and 65 to qualify for coverage</span>
                        </v-col>
                        <v-col cols="5" sm="3" md="5">
                            <span class="input-control-text">Zip Code</span>
                            <v-text-field
                                outlined
                                :rules="[zip_code_validate, rules.zipcode]"
                                v-model="zipCode"
                                ref="fld_zipCode"
                                hide-details="auto"
                                class="input-control-text"
                                dense
                                placeholder="12345"
                                id="zip"
                                type="text"
                                inputmode="numeric"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="5" md="12">
                            <span class="input-control-text">Coverage Amount<CoverageAmountHelpDialog></CoverageAmountHelpDialog></span>

                            <v-text-field
                                v-if="cov_amount_treatment"
                                outlined
                                v-model="coverage_amount"
                                :rules="isOCSite ? [] : [rules.covLimit]"
                                hide-details="auto"
                                dense
                                class="input-control-text field-medium"
                                type="text"
                                inputmode="numeric"
                                @input="formatCoverage"
                                placeholder="$25,000 - $1,000,000"
                                >
                            </v-text-field>
                            <v-select
                                v-else
                                id="coverage_amnt-mp_tl"
                                outlined
                                v-model="coverage_amount"
                                hide-details="auto"
                                :items="coverage_items"
                                dense
                                ref="dd_coverage_amount"
                                class="input-control-text mt-2"
                                :rules="isOCSite ? [] : [rules.covLimit]"
                                >
                            </v-select>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="6" md="12">
                            <div class="input-control-text mb-2">Term Length <TermLengthHelpDialog :agent-data="dialogData"></TermLengthHelpDialog></div>
                                <div :class="termlengthError ? 'error-outline' : ''">
                                    <v-btn
                                        depressed
                                        class="ml-1 mt-1 toggle-btn"
                                        v-for="(data,idx) in plan_items"
                                        :key="idx"
                                        @click="coverage_plan = data.value"
                                        :color="coverage_plan === data.value ? selectedBtnColor : null"
                                        :dark="isOCSite && coverage_plan === data.value"
                                    >
                                        <span class="input-control-text toggle-btn-label">{{data.text}}</span>
                                    </v-btn>
                                </div>
                                <div v-if="termlengthError" class="q-error-text font-weight-light">
                                    Required.
                                </div>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="6" md="12">
                            <div class="input-control-text mb-2">Gender at Birth <GenderHelpDialog></GenderHelpDialog></div>
                            <div :class="genderError ? 'error-outline' : ''">
                                <v-btn
                                    depressed
                                    class="ml-1 mt-1 toggle-btn"
                                    @click="gender = 'Male'"
                                    :color="gender === 'Male' ? selectedBtnColor : null"
                                    :dark="isOCSite && gender === 'Male'"
                                >
                                    <span class="input-control-text toggle-btn-label">Male</span>
                                </v-btn>
                                <v-btn
                                    depressed
                                    class="ml-1 mt-1 toggle-btn"
                                    @click="gender = 'Female'"
                                    :color="gender === 'Female' ? selectedBtnColor : null"
                                    :dark="isOCSite && gender === 'Female'"
                                >
                                    <span class="input-control-text toggle-btn-label">Female</span>
                                </v-btn>
                            </div>
                            <div v-if="genderError" class="q-error-text font-weight-light">
                                Required.
                            </div>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="6" md="12">
                            <div class="input-control-text">Tobacco Used in Last 12 Months <TobaccoHelpDialog></TobaccoHelpDialog></div>
                            <div :class="tobaccoError ? 'error-outline' : ''">
                                <v-btn
                                    depressed
                                    class="ml-1 mt-1 toggle-btn"
                                    @click="tobacco_used = 'Yes'"
                                    :color="tobacco_used === 'Yes' ? selectedBtnColor : null"
                                    :dark="isOCSite && tobacco_used === 'Yes'"
                                >
                                    <span class="input-control-text toggle-btn-label">Yes</span>
                                </v-btn>
                                <v-btn
                                    depressed
                                    class="ml-1 mt-1 toggle-btn"
                                    @click="tobacco_used = 'No'"
                                    :color="tobacco_used === 'No' ? selectedBtnColor : null"
                                    :dark="isOCSite && tobacco_used === 'No'"
                                >
                                    <span class="input-control-text toggle-btn-label">No</span>
                                </v-btn>
                            </div>
                            <div v-if="tobaccoError" class="q-error-text font-weight-light">
                                Required.
                            </div>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="6" md="12">
                            <div class="input-control-text mb-n8">Personal Information</div>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="6" sm="3" md="6">
                            <v-text-field
                                label="First Name"
                                outlined
                                :rules="[rules.required]"
                                v-model="firstName"
                                hide-details="auto"
                                class="input-control-text"
                                dense
                                id="first_name"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="6" sm="3" md="6">
                            <v-text-field label="Last Name"
                                        outlined
                                        :rules="[rules.required]"
                                        v-model="lastName"
                                        hide-details="auto"
                                        class="input-control-text"
                                        dense
                                        id="last_name"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="6" md="12">
                            <v-text-field label="Email Address"
                                        outlined
                                        :rules="[rules.email]"
                                        v-model="email"
                                        hide-details="auto"
                                        class="input-control-text"
                                        dense
                                        height="20"
                                        id="email"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="6" md="12">
                            <v-text-field
                                label="Phone Number"
                                outlined
                                :rules="[rules.phone]"
                                v-model="phoneNumber"
                                hide-details="auto"
                                class="input-control-text"
                                dense
                                placeholder="(###)-###-####"
                                v-mask="'(###)-###-####'"
                                id="phone"
                                type="text"
                                inputmode="numeric"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="6" md="12">
                            <div class="input-control-text">Speak to a Representative in:</div>
                            <v-btn
                                depressed
                                class="ml-1 mt-1 toggle-btn"
                                @click="Spanish_Speaking = false"
                                :color="Spanish_Speaking === false ? selectedBtnColor : null"
                                :dark="isOCSite && Spanish_Speaking === false"
                            >
                                <span class="input-control-text toggle-btn-label">English</span>
                            </v-btn>
                            <v-btn
                                depressed
                                class="ml-1 mt-1 toggle-btn"
                                @click="Spanish_Speaking = true"
                                :color="Spanish_Speaking === true ? selectedBtnColor : null"
                                :dark="isOCSite && Spanish_Speaking === true"
                            >
                                <span class="input-control-text toggle-btn-label">Spanish</span>
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <div v-if="!otp_treatment && ts_treatment" class="pl-2">
                                <div id="cf-turnstile-container"></div>
                            </div>

                            <v-btn
                                class="input-control-text mt-4 btn-no-transform"
                                type="button"
                                @click="sumitForm"
                                large block depressed dark
                                id="btnRAQ"
                                color="q-secondary"
                            >
                                Get My Quote
                            </v-btn>
                            <!-- <v-btn color="success" @click="test">test</v-btn> -->

                        </v-col>
                        <v-col v-if="quote_error">
                            <div class="quote-error-msg">
                                {{quote_error_message}}
                            </div>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-form>
        <v-dialog
            v-model="dialog"
            persistent
            width="300"
            class="loading-dialog"
        >
            <v-card
                color="#005851"
                dark
            >
                <v-card-text class="pa-3 loading-dialog-text">
                    Generating Quote
                    <v-progress-linear
                        indeterminate
                        color="white"
                        class="mb-0 mt-4"
                    ></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
        <SubscriptionDialog v-model="subscription_dialog" :zoho-id="zohoid"></SubscriptionDialog>
    </div>
</template>

<script>
import SubscriptionDialog from "@/components/SubscriptionDialog";
import quilityMixin from "@/mixins/quilityMixin";
import TobaccoHelpDialog from "@/components/TobaccoHelpDialog";
import GenderHelpDialog from "@/components/GenderHelpDialog";
import TermLengthHelpDialog from "@/components/TermLengthHelpDialog";
import CoverageAmountHelpDialog from "@/components/CoverageAmountHelpDialog";

export default {
    name: "RAQForm",
    components: {
        CoverageAmountHelpDialog,
        TermLengthHelpDialog,
        GenderHelpDialog,
        TobaccoHelpDialog,
        SubscriptionDialog,
    },
    mixins:[quilityMixin],
    props: {
        plan_lists: {
            type: Object,
            default: function () {
                const terms = [
                    {text: '10 Years', value: '10 Years'},
                    {text: '15 Years', value: '15 Years'},
                    {text: '20 Years', value: '20 Years'},
                    {text: '25 Years', value: '25 Years'},
                    {text: '30 Years', value: '30 Years'},
                ];
                return {terms};
            }
        },
        amam_only_states: {
            type: Array,
            default: function() {
                return ['FL', 'ND'];
            }
        },
    },
    data: () => ({
        subscription_dialog: false,
        coverage_amt_dialog: false,
        term_length_dialog: false,
        gender_dialog: false,
        tobacco_dialog: false,
        valid: false,
        plan_items: [
                {text: '10 Years', value: '10 Years'},
                {text: '15 Years', value: '15 Years'},
                {text: '20 Years', value: '20 Years'},
                {text: '25 Years', value: '25 Years'},
                {text: '30 Years', value: '30 Years'},
                {text: '35 Years', value: '35 Years'},
                {text: '40 Years', value: '40 Years'},
            ],
        coverage_amount: null,
        coverage_plan: null,
        gender: null,
        age: null,
        tobacco_used: null,
        zipCode: null,
        lastName: null,
        firstName: null,
        email: null,
        phoneNumber: null,
        coverage_limit: 40,
        coverage_items: [],
        fld_zipCode: 'fld_zipCode',
        state_id: null,
        city: null,
        zipError: null,
        quote_error: false,
        quote_error_message: null,
        select: [],
        dialog: false,
        api_url: process.env.VUE_APP_PROXY,
        agentInfo: {},
        leadType:'Quility',
        isConversion: false,
        Spanish_Speaking: false,
        dob: null,
        dob_focus: false,
        coverage_plan_meh:null,
        genderError: false,
        tobaccoError: false,
        termlengthError: false,
        create_time: null,
        submit_time: null,
        county: null,
        ts_validated: false,
        ts_id: null
    }),
    computed: {
        term_length_validate: function () {
            return value => !!value || 'Required.'
        },
        coverage_amount_validate: function () {
            return value => !!value || 'Required.'
        },
        zip_code_validate: function() {
            if(this.zipError === 'error') {
                return false || 'Zip code does not exist';
            }
            return v => Number.isInteger(Number(v)) && Number(v) < 99999 && (v !== null && v.length == 5) || 'Enter a valid zipcode'
        },
        outside_age_range(){
            if(this.age == null || this.age == undefined){
                return true
            }

            // console.log('age', this.age)
            // return this.date_diff_days(this.dob, new Date()) > (18 * 365) || 'Age must be greater than 18'
            return (this.age >= 18 && this.age <= 65) || 'Please enter an age between 18 and 65'
        },
        dialogData(){
            return {
                'site': this.site,
                'agentPhone': this.agent.agentPhone
            }
        },
        selectedBtnColor() {
            return this.isOCSite ? 'q-secondary' : 'q-primary'
        }
    },
    watch: {
        zipCode: function (value) {
            if (value.length === 5) {
                this.getStateByZipCode(value);
            }
        },
        dob: function(newValue) {
            if(newValue.length < 10) {
                return false;
            }

            this.age = this.insuranceAge(newValue);

            // Hatch/OC instance: skip age-based restrictions on
            // term lengths and coverage amounts so the user can
            // always request a quote regardless of age.
            if(this.isOCSite) {
                this.coverage_items = this.setCoverageItems(25000, 2000000)
                return;
            }

            // update term length options based on age
            this.plan_items = this.setTermLengths(this.age)

            // update max coverage amount
            let maxCoverage = 2000000

            if(this.age >= 61 && this.age <= 65){
                maxCoverage = 250000
            } else if (this.age >= 51 && this.age <= 60) {
                maxCoverage = 500000
            }

            // reset coverage amount if it falls outside of
            // the new coverage amount range
            if(this.coverage_amount < 25000 || this.coverage_amount > maxCoverage){
                this.coverage_amount = null
            }

            this.coverage_items = this.setCoverageItems(25000, maxCoverage)
        },
        tobacco_used: function(newValue) {
            if(newValue != null && newValue != undefined){
                this.tobaccoError = false
            }
        },
        gender: function(newValue) {
            if(newValue != null && newValue != undefined){
                this.genderError = false
            }
        },
        coverage_plan: function(newValue) {
            if(newValue != null && newValue != undefined){
                this.termlengthError = false
            }
        },
        ts_validated: function(v) {
            if(v === true){
                setTimeout(() => {
                    turnstile.remove(this.ts_id)
                }, 1000);
            }
        }
    },
    mounted() {
        this.create_time = new Date()
        this.coverage_items = this.setCoverageItems();

        const inputElement = this.$refs.fld_zipCode.$el.querySelector('input');
        inputElement.maxLength = 5;
        this.plan_items = this.plan_lists.terms;

        let routePath = this.$route.path;
        routePath = routePath.split('/');
        if(routePath[1] === 'symmetry') {
            this.leadType = 'OC DTC Lead';
        }

        if(!this.otp_treatment && this.ts_treatment){
            /*global turnstile*/
            turnstile.ready(() => {
                this.ts_id = turnstile.render('#cf-turnstile-container', {
                    sitekey: process.env.VUE_APP_CF_TS_SITE_KEY,
                    callback: async (token) => {
                        let res = await fetch(this.api_url + 'process-ts', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'Access-Control-Allow-Origin': '*'
                            },
                            body: JSON.stringify({'cf-ts-token': token}),
                        })

                        const data = await res.json()
                        this.ts_validated = data.success ?? false
                    },
                    theme: 'light',
                    action: process.env.VUE_APP_CF_ACTION,
                })
            })
        }

        // populate with fields in the store if possible
        if(this.form.dob){
            this.dob = this.form.dob
        }

        if(this.form.zip_code){
            this.zipCode = this.form.zip_code
        }

        if(this.form.zip_code){
            this.zipCode = this.form.zip_code
        }

        if(this.form.coverage_amount) {
            this.coverage_amount = this.form.coverage_amount
        }

        if(this.form.coverage_plan) {
            this.coverage_plan = this.form.coverage_plan
        }

        if(this.form.gender) {
            this.gender = this.form.gender
        }

        if(this.form.tobacco_used) {
            this.tobacco_used = this.form.tobacco_used
        }

        if(this.form.first_name) {
            this.firstName = this.form.first_name
        }

        if(this.form.last_name) {
            this.lastName = this.form.last_name
        }

        if(this.form.email) {
            this.email = this.form.email
        }

        if(this.form.phone_number) {
            this.phoneNumber = this.form.phone_number
        }

        if(this.form.Spanish_Speaking) {
            this.Spanish_Speaking = this.form.Spanish_Speaking
        }

        // console.log('treatments', this.treatments)
    },
    methods:{
        async getStateByZipCode(zipcode) {
            let ste_url = this.api_url + 'zip-code-quility';

            const postParam = {'zipcode':zipcode};

            try {
                let res = await fetch(ste_url,{
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Origin': '*'
                    },
                    body: JSON.stringify(postParam),
                })
                let json_data = await res.json()

                this.zipError = '';
                if(json_data.status === 'error') {
                    this.zipError = 'error';
                    return false;
                }

                this.state_id = json_data.zip_info.state_id;
                this.city = json_data.zip_info.city;
                this.county = json_data.zip_info.county_name

            } catch (error) {
                console.error('raqform->getStateByZipCode->error', error)
            }
        },
        /* eslint-disable no-unused-vars */
        async requestQuote(_e) {
            const urlParams = new URLSearchParams(window.location.search);
            this.submit_time = new Date()
            let product_type = urlParams.get('p') ?? '';
            let ste_url = this.api_url + 'get-quote';

            let client = await this.$split_client.latest

            // users who have clicked the Request A Quote button
            client.track('anonymous', 'form.click.request-quote')

            if(this.coverage_amount !== null && this.coverage_amount !== undefined){
                // users who have entered a value for the coverage amount
                // and clicked the Request A Quote button
                client.track('anonymous', 'form.dtc.coverage-amount-field-completion')
            }

            if(this.gender == null) {
                this.genderError = true
            }

            if(!this.tobacco_used) {
                this.tobaccoError = true
            }

            if(!this.coverage_plan) {
                this.termlengthError = true
            }

            if (this.$refs.form.validate() === false) {
                return false;
            }

            if(this.genderError || this.tobaccoError || this.termlengthError) {
                return false
            }

            if((!this.otp_treatment && this.ts_treatment) && this.ts_validated === false){
                turnstile.reset(this.ts_id)
                return false
            }

            this.dialog = true;

            if(this.Spanish_Speaking === true)
            {
                product_type = 'Spanish-MP';
            }
            else{
                product_type = (typeof product_type!='undefined' && product_type.toUpperCase() === 'MP') ? 'Mortgage Protection' : 'Term Life';
            }

            const d = new Date(this.dob)
            let dob_m = '' + (d.getMonth() + 1)
            let dob_d = '' + d.getDate()
            let dob_y = d.getFullYear()

            if(dob_m.length < 2){
                dob_m = '0' + dob_m
            }

            if(dob_d.length < 2){
                dob_d = '0' + dob_d
            }

            const q_agent = this.agent

            let ref_site = (this.site === 'OC') ? this.$route.query.redirect_url : (this.$cookies.get('set_referring_url')) ? this.$cookies.get('set_referring_url') : document.referrer

            const formattedCovAmt = this.cov_amount_treatment ? this.coverage_amount.replace(/[^\d.-]/g, '') : this.coverage_amount

            let postParam = {
                gender: this.gender,
                productType: product_type,
                smoker: this.tobacco_used,
                zip: this.zipCode,
                dob: `${dob_y}-${dob_m}-${dob_d}`,
                coverage_amount: formattedCovAmt,
                term_length: this.coverage_plan,
                firstName: this.firstName,
                lastName: this.lastName,
                email: this.email,
                phone: this.phoneNumber,
                state_id: this.state_id,
                city: this.city,
                age: this.age,
                entry_point: process.env.VUE_APP_LEADENTRYPOINT,
                mode: 'create',
                site:this.site,
                zoho_id: null,
                agentInfo:{...q_agent, site:this.site},
                leadType:this.leadType,
                referrer: ref_site,
                utm_source:this.$cookies.get('utm_source'),
                utm_medium: this.$cookies.get('utm_medium'),
                utm_campaign: this.$cookies.get('utm_campaign'),
                utm_token: this.$cookies.get('utm_token'),
                utm_content: this.$cookies.get('utm_content'),
                gclid: this.$cookies.get('gclid'),
                Spanish_Speaking: this.Spanish_Speaking,
                SetSupportStatus: this.tky,
                IsOCInstance: this.isOCSite,
            }

            this.$store.commit('updateForm', {
                dob: this.dob,
                coverage_amount: this.coverage_amount,
                coverage_plan: this.coverage_plan,
                gender: this.gender,
                tobacco_used: this.tobacco_used,
                zip_code: this.zipCode,
                first_name: this.firstName,
                last_name: this.lastName,
                email: this.email,
                phone_number: this.phoneNumber,
                spanish_speaking: this.Spanish_Speaking,
                state_id: this.state_id,
                city: this.city,
                product_type: product_type,
                age: this.age,
                lead_type: this.leadType,
                dob_formatted: `${dob_y}-${dob_m}-${dob_d}`,
                county_name: this.county,
            })

            try {
                let res = await fetch(ste_url,{
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Origin': '*'
                    },
                    body: JSON.stringify(postParam),
                })
                let json_data = await res.json()

                this.$store.commit('updateQuoteData', json_data)

                this.dialog = false;
                if(json_data.errors) {
                    this.subscription_dialog = true;
                    return false;
                }

                if (json_data.success === true) {
                    // log if bot lead
                    if(this.tky){
                        client.track('anonymous', 'form.botd.opensource.botlead', null, {
                            form: JSON.stringify(this.form),
                        })
                    }

                    let quotes = json_data.quotes ?? [];
                    if(this.state_id === 'NY') {
                        quotes = quotes.filter(function(item) {
                            return item.Carrier !== 'John Hancock';
                        });
                    }

                    // push lead to switchboard for OC DTC leads
                    if(this.site == 'OC') {
                        try {
                            await this.routeToSwitchboardOC()
                        } catch (error) {
                            console.error('raqform->checkQuote->error', error)
                        }
                    }

                    let quoteParams = {};
                    quoteParams['quotes'] = !!quotes === true ? quotes : [];
                    quoteParams['form_data'] = postParam;
                    quoteParams['agentInfo'] = {...this.agent, site:this.site};
                    quoteParams['site'] = this.site;
                    quoteParams['leadType'] = this.leadType;
                    quoteParams['oc_redirect_url'] = this.$route.query.redirect_url;
                    quoteParams['product_type'] = product_type;

                    this.$store.commit('updateQuoteParams', quoteParams)

                    this.isConversion = (json_data?.scores?.emailMatch || json_data?.scores?.phoneMatch)

                    // only log conversions
                    // when either the phone or email
                    // for this lead is valid.
                    if(this.isConversion)
                    {
                        this.logEvent(product_type, 'RAQ_Complete', 'Created Lead')
                        this.logBingConversion(product_type, 'RAQ_Complete', 'Created Lead');
                        this.logFBConversion(product_type, 'RAQ_Complete', 'Created Lead');
                    }

                    if(this.site === 'OC') {

                        // Determine if the lead has any valid quotes
                        let noValidQuotes = quotes.length === 0
                        if(!noValidQuotes) {
                            noValidQuotes = true
                            for (const q of quotes) {
                                if(this.isset(q.Premium)) {
                                    noValidQuotes = false
                                    break
                                }
                            }
                        }

                        if(!this.lead_routed){
                            // OC-1509: Capture External Partner Id from routeOCToQLM for case tracking
                            const leadResult = await this.routeOCToQLM(noValidQuotes)
                            if (leadResult) {
                                // Update lead_routed state based on success
                                if (leadResult.success) {
                                    this.$store.commit('updateLeadRouted', leadResult.success)
                                }
                                // Capture externalPartnerId for case tracking
                                if (leadResult.externalPartnerId) {
                                    this.$store.commit('updateExternalPartnerId', leadResult.externalPartnerId)
                                }
                            }
                        }

                        if(noValidQuotes) {
                            // DTC Not Eligible: redirect to "agent will contact you" page
                            this.$router.push({name: 'HatchThankyou'});
                        } else {
                            this.$router.push({name: 'Symm-quotes', params: quoteParams});
                        }

                    } else {
                        let noQuoteData = quotes.length === 0

                        for (const q of quotes) {
                            if(this.isset(q.Premium)) {
                                noQuoteData = false
                            }
                        }

                        const routeName = noQuoteData === true ? 'QuotesThankYou' : 'Results'

                        // console.log('quotes',JSON.stringify(json_data.quotes))
                        // console.log('noQuoteData',noQuoteData,'routeName',routeName)

                        this.$router.push({name: routeName, params: quoteParams})
                    }
                }
                else if(json_data.success === false) {
                    this.quote_error = true;
                    this.quote_error_message = 'Error!. Please try again later.';
                }
            } catch (error) {
                console.error('raqform->checkQuote->error', error)
            }

        },
        insuranceAge: function (original_dob) {
            if (original_dob === '' || original_dob === null) {
                return;
            }

            // Age calculation based off of the following logic/example:
            // The way carriers look at nearest age is DOB and 7 full months, it will roll to the next age.
            // Ex:
            // DOB is 1/28/2000
            // Todays Date is 07/28/2023
            // Insurance age: 23
            // On 07/29/2023 insurance age changes to 24

            let todaysDate = new Date() // todays date
            let bd = new Date(original_dob) // birthdate and birth year
            let calculatedAge = todaysDate.getFullYear() - bd.getFullYear();

            // decrement since birthday for this year hasn't occured yet
            if(todaysDate.getMonth() < bd.getMonth()){
                calculatedAge--
            }

            // birthdate and current year
            let bdCurYear = new Date(original_dob)
            bdCurYear.setFullYear(todaysDate.getFullYear())

            let monthDiff = this.getMonthsBetween(bdCurYear, todaysDate, true)

            if(monthDiff >= 7) {
                calculatedAge++
            }

            this.age = calculatedAge
            return calculatedAge
        },
        formatCoverage() {
            if(this.coverage_amount === '$'){
                return
            }

            this.coverage_amount = this.stripNonNumbericChars(this.coverage_amount)
        },
        sumitForm(){
            // manually triggering form submit event
            // to help with amplitude tracking
            this.$refs.form.$el.requestSubmit()
        },
    },
}
</script>

<style scoped>
    .form-card {
        border-radius: 10px !important;
    }

    .field-medium {
        width: 400px;
    }

    .toggle-btn {
        width: 100px;
    }

    .toggle-btn.q-secondary:hover {
        background-color: #003E3A !important;
    }

    .toggle-btn.q-secondary:active {
        background-color: #002522 !important;
    }

    .toggle-btn-label {
        width: 80px;
    }

    .btn-no-transform {
        text-transform: none;
    }

    .quote-error-msg {
        font: italic normal 300 11px/16px "Montserrat", sans-serif;
        color: #FF0000;
    }

    .loading-dialog {
        font-family: "Montserrat", sans-serif;
    }

    .loading-dialog-text {
        font-family: "Montserrat", sans-serif;
        font-size: 1rem;
        line-height: 1rem;
    }

    .q-error-text{
        color: red;
        padding-left: 16px;
        padding-right: 16px;
        overflow-wrap: break-word;
        hyphens: auto;
        line-height: 12px;
        margin-top: 4px;
        font-size: 12px !important;
        font-family: "Montserrat", Sans-serif !important;
    }
    .error-outline{
        border: 2px solid red;
        border-radius: 5px;
        padding: 5px
    }
    .v-messages {
        min-height: 1px;
    }
    .get-a-quote-container {
        font-family: montserrat, Sans-serif;
    }

    .get-a-quote-title {
        font-family: "Montserrat", Sans-serif !important;
        font-weight: 300;
        text-align: left;
        line-height: 1em;
        color: #002421;
    }

    .estimate-msg {
        font-size: 3rem;
        color: #46C3B2;
        font-family: "Montserrat", sans-serif !important;
        line-height: 1.3em;
        font-weight: 900;
    }

    .med-thin-text {
        margin-top: 3%;
        font-size: calc(18px + (35 - 22) * ((100vw - 400px) / (2000 - 400))) !important;
        font-family: "Montserrat", Sans-serif !important;
        font-weight: 300;
        line-height: 2.5rem;
        color: #000000;
    }

    .breaking-border {
        background: #DAF3F0;
        width: 51.58px;
        height: 8.38px;
        margin-top: 2%;
    }

    .coverage-title-container {
        font-size: 0.9rem;
        line-height: 1.2rem;
        color: white;
        background: #46C3B2;
        font-family: montserrat, Sans-serif
    }

    .input-control-text {
        font-family: "Montserrat", Sans-serif !important;
    }

    .input-control-text-small {
        font-family: "Montserrat", Sans-serif !important;
        font-size: smaller;
    }
    .price-teaser-period {
        font-size: 0.8rem;
    }

    .dialog-text {
        font-family:Montserrat; font-weight: normal; font-size: 0.8rem;  color: black;
    }

    .theme--light.v-btn.v-btn--has-b {
        background-color: #005951;
        color: white;
    }

    @media only screen and (max-width: 768px) {
        .estimate-msg {
            font-family: "Montserrat", sans-serif !important;
            font-size: 2rem;
            line-height: 1.2em;
            margin-bottom:0;

        }

        .get-a-quote-block {
            font-size: 0.8rem;
            white-space: pre-wrap;
            word-break: keep-all;
        }

        .price-teaser {
            margin-top:14%;
        }

        .price-teaser-period {
            margin-top:6%;
            font-size: 0.8rem;
            white-space: nowrap;
            word-break: keep-all;
        }

        input::-webkit-input-placeholder{
            color:red;
        }
        input:-moz-placeholder {
            color:red;
        }
    }
</style>
